import { useEffect } from "react";

const SITE_URL = "https://brightsolutions.pro";

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs).forEach(([k, v]) => {
      if (k !== "content") el.setAttribute(k, v);
    });
    document.head.appendChild(el);
  }
  el.setAttribute("content", attrs.content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector("link[rel='canonical']");
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Lightweight SEO hook that updates <title>, meta description, canonical and
 * Open Graph / Twitter tags on route change.
 */
export default function useSEO({ title, description, path = "/" }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | Bright Solutions Europe`
      : "Bright Solutions Europe — Meta Ads · Google Ads · SEO · Warsaw";
    const desc =
      description ||
      "Bright Solutions Europe is a Warsaw-based performance marketing agency. We scale brands with Meta Ads, Google Ads and SEO across Europe.";
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;

    upsertMeta("meta[name='description']", {
      name: "description",
      content: desc,
    });
    upsertCanonical(url);

    upsertMeta("meta[property='og:title']", {
      property: "og:title",
      content: fullTitle,
    });
    upsertMeta("meta[property='og:description']", {
      property: "og:description",
      content: desc,
    });
    upsertMeta("meta[property='og:url']", {
      property: "og:url",
      content: url,
    });
    upsertMeta("meta[name='twitter:title']", {
      name: "twitter:title",
      content: fullTitle,
    });
    upsertMeta("meta[name='twitter:description']", {
      name: "twitter:description",
      content: desc,
    });
  }, [title, description, path]);
}
